import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")

  return _withDirectives((_openBlock(), _createBlock(_component_router_view, {
    functionalityId: _ctx.functionalityId,
    item: _ctx.loadedItem,
    parameterValuesMap: _ctx.parameterValuesMap,
    tabKey: _ctx.key,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close', _ctx.item))),
    onParametersChanged: _ctx.onParametersChange,
    onIframeCreated: _ctx.onIframeCreated,
    onCloseIframe: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeIframe'))),
    onCloseDetails: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close', _ctx.item))),
    onDocumentSaved: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('documentSaved', $event)))
  }, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _ctx.key,
          functionalityId: _ctx.functionalityId,
          item: _ctx.loadedItem,
          parameterValuesMap: _ctx.parameterValuesMap,
          tabKey: _ctx.key
        }, null, 8, ["functionalityId", "item", "parameterValuesMap", "tabKey"]))
      ], 1024))
    ]),
    _: 1
  }, 8, ["functionalityId", "item", "parameterValuesMap", "tabKey", "onParametersChanged", "onIframeCreated"])), [
    [_vShow, _ctx.item]
  ])
}